import { createRequest, getApiError } from "Utils/requestUtils";
import { CallEffect, call, debounce, put } from "redux-saga/effects";
import {
  AddressSuggestion,
  OperationType,
} from "./addressSuggestionsInterfaces";
import {
  fetchAddressSuggestionsStart,
  fetchAddressSuggestionsSuccess,
  operationFailed,
} from "./addressSuggestionsSlice";

import { resetEstateInformation } from "Store/estate/estateSlice";
import { recordAddressSuggestionsIfRecording } from "Utils/fixtureRecordingUtils";
import { AxiosResponse } from "axios";
import { isPartialAddressValid } from "./addressSuggestionsValidation";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* handleFetchAddressSuggestions({
  payload,
}: ReturnType<typeof fetchAddressSuggestionsStart>) {
  const { query, limit } = payload;

  try {
    yield put(resetEstateInformation());
    if (isPartialAddressValid(query)) {
      yield call(fetchAddressSuggestions, query, limit);
    } else {
      yield put(fetchAddressSuggestionsSuccess([]));
    }
  } catch (e) {
    yield put(
      operationFailed(getApiError(e, OperationType.GET_ADDRESS_SUGGESTIONS)),
    );
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchAddressSuggestions(partialAddress: string, limit = 5) {
  const addressSuggestions = (yield call(
    fetchAddressSuggestionsActual,
    partialAddress,
    limit,
  )) as AddressSuggestion[];
  recordAddressSuggestionsIfRecording(addressSuggestions);
  yield put(fetchAddressSuggestionsSuccess(addressSuggestions));
}

function* fetchAddressSuggestionsActual(
  partialAddress: string,
  limit: number,
): Generator<
  CallEffect<AxiosResponse<unknown>>,
  AddressSuggestion[],
  AxiosResponse<AddressSuggestion[]>
> {
  const { data: addressSuggestions } = yield call(createRequest, {
    method: "post",
    requestBody: { partialAddress },
    url: `/open/insurance/address/suggestions?limit=${limit}`,
  });
  return addressSuggestions;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* addressSuggestionsSaga() {
  yield debounce(
    300,
    fetchAddressSuggestionsStart,
    handleFetchAddressSuggestions,
  );
}
